export function parseMetaCallback(search: string): {
  ticket: string | null;
  purpose: "LOGIN" | "LINK" | "BUSINESS_CONNECT" | null;
  provider: "FACEBOOK" | "INSTAGRAM" | null;
} {
  const params = new URLSearchParams(search);
  const ticket = params.get("ticket");
  const purpose = params.get("purpose");
  const provider = params.get("provider") ?? "FACEBOOK";
  if (
    params.has("error") ||
    params.getAll("ticket").length !== 1 ||
    params.getAll("purpose").length !== 1 ||
    params.getAll("provider").length > 1 ||
    !["FACEBOOK", "INSTAGRAM"].includes(provider) ||
    !ticket ||
    !/^[A-Za-z0-9_-]{43}$/.test(ticket)
  )
    return { ticket: null, purpose: null, provider: null };
  return {
    ticket,
    provider: provider as "FACEBOOK" | "INSTAGRAM",
    purpose:
      purpose === "LOGIN" ||
      purpose === "LINK" ||
      purpose === "BUSINESS_CONNECT"
        ? purpose
        : null,
  };
}
